import { EmailAlertIcon } from './EmailAlertIcon';

/**
 * author: Austin Andrews
 * id 8031577D-2528-4278-9F7B-93BD5DED18E3
 * name email-alert
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-alert.svg
 * tags
 * - Alert / Error 
 */
export const EmailWarningIcon = EmailAlertIcon;
export default EmailWarningIcon